import * as actionType from './actionTypes';

const initialState = {
  userData: null,
  isLoading: false,
  notifications: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_USER_DATA:
      return { ...state, userData: action.payload };

    case actionType.SET_LOADER_SCREEN:
      return { ...state, isLoading: action.payload };

    case actionType.SET_NOTIFICATION_DATA:
      return { ...state, notifications: [...state.isLoading.notifications, action.payload] };
    default:
      return state;
  }
};

export default reducer;
